export default "__VITE_ASSET__3f5f24d4__"